module.exports = __webpack_public_path__ + "static/hyperv_13.1712b6e7.jpg";